import React, { memo, useMemo } from "react";
import { Icon } from '../../components';
import {Connections as ConnectionIcon} from '../../icons'
import { useMfwThemeProvider } from "myfitworld-utils";


const Connections = () => {
  const strokeColor = useMfwThemeProvider().mfwMuiWebTheme.palette.text.primary;

  const styes = useMemo(() => {
    return { stroke: strokeColor, fill: 'none' }
  }, [strokeColor])

  return (
    <Icon icon={ConnectionIcon} style={styes} />
  );
};

export default memo(Connections);
